import { type Dispatch, useEffect } from 'react';
import { getLastSearchFhh } from '../../common/lastSearch';
import actions from '../fhhActions';
import type { FhhState } from '../fhhDefaultState';

export const useFhhInitialState = (dispatch: Dispatch<ReturnType<(typeof actions)[keyof typeof actions]>>, prefill?: Partial<FhhState>) => {
    useEffect(() => {
        dispatch(actions.allFieldsChanged({ ...getLastSearchFhh(), ...prefill }));
    }, [dispatch, prefill]);
};
